import { DIFFICULTIES, type Difficulty } from "../config";
import type { GameAction } from "../core/types";

/** Oyun ayarları — menüden seçilir, oyun mantığına saf veri olarak geçer. */
export interface GameSettings {
  difficultyIndex: number;
  wallPass: boolean;
  progressive: boolean;
  sound: boolean;
}

export function createDefaultSettings(): GameSettings {
  return {
    difficultyIndex: 1, // MEDIUM
    wallPass: true,
    progressive: true,
    sound: true,
  };
}

/** Ayar seçimindeki satır sayısı: zorluk, duvar, hız modu, ses, başla. */
export const MENU_ITEM_COUNT = 5;
/** "OYUNA BASLA" satırının indeksi. */
export const MENU_START_INDEX = MENU_ITEM_COUNT - 1;

export function difficultyOf(settings: GameSettings): Difficulty {
  return DIFFICULTIES[settings.difficultyIndex];
}

/** Menü satırını döngüsel olarak yukarı/aşağı taşır. */
export function navigateMenu(index: number, delta: -1 | 1): number {
  return (index + delta + MENU_ITEM_COUNT) % MENU_ITEM_COUNT;
}

/**
 * Seçili satırı soldan-sağa/sağdan-sola (veya A ile) değiştirir ve settings'i
 * yerinde günceller. "Başla" satırı burada işlem görmez — arayan karar verir.
 */
export function changeMenuItem(index: number, delta: -1 | 1, settings: GameSettings): void {
  switch (index) {
    case 0:
      settings.difficultyIndex =
        (settings.difficultyIndex + delta + DIFFICULTIES.length) % DIFFICULTIES.length;
      break;
    case 1:
      settings.wallPass = !settings.wallPass;
      break;
    case 2:
      settings.progressive = !settings.progressive;
      break;
    case 3:
      settings.sound = !settings.sound;
      break;
  }
}

/**
 * Ayar ekranındaki bir eylemi işler: "left/right/ok" seçili satırın değerini
 * değiştirir. "Başla" satırı ve gezinme burada işlem görmez — arayan karar verir.
 */
export function applySettingsAction(
  index: number,
  action: GameAction,
  settings: GameSettings,
): void {
  const delta: -1 | 1 | null = action === "left" ? -1 : action === "right" || action === "ok" ? 1 : null;
  if (delta === null || index === MENU_START_INDEX) return;
  changeMenuItem(index, delta, settings);
}
